// 独立的页面性能检测代码，可服用

const ASSETS_TYPE = ['script', 'link'];
// const URL_TYPE = ['moneydata.hk', 'wechatpay.com.hk', 'res.wx.qq.com'];

/**
 * 获取页面性能数据
 * @param pageTiming 页面出现有意义的画面时间
 * @returns
 */
export const collectPageInfo = (pageTiming?: number): PerformanceType => {
  const { timing: t } = performance;
  // 开始导航至DCL耗时
  const DCLTime = t.domContentLoadedEventEnd - t.navigationStart;
  let assetsEntries: PerformanceResourceTiming[] = [];
  const collectEntryType = 'resource';
  // 筛选适合的entries
  assetsEntries = processEntries(performance.getEntriesByType(collectEntryType) as PerformanceResourceTiming[])
    // 筛选 DCL 耗时之前加载的资源，避免 prefetch 加载其他资源影响结果。
    .filter(item => item.startTime < DCLTime);
  // 资源中最后加载完毕的时间
  const lastResourceTime = assetsEntries
    .reduce((endTime, entry) => (entry.responseEnd > endTime ? entry.responseEnd : endTime), 0);
  // 资源中最先开始加载的时间
  const firstResourceTime = assetsEntries
    .reduce((startTime, entry) => (entry.startTime < startTime ? entry.startTime : startTime), Number.MAX_SAFE_INTEGER);

  // 从开始导航至TTFB时间
  const connectTime = t.responseStart - t.navigationStart;
  // 看到首个有效信息时间，默认为 DomContentLoaded 事件时间
  const FCPTime = pageTiming ? pageTiming : DCLTime;
  // 将开始导航，至 responseEnd，作为完整加载HTML时间
  const HTMLDownloaded = t.responseEnd - t.responseStart;
  // 将最后一个资源加载完成时间，减去第一个资源加载开始时间，作为资源加载时间
  const resourceLoaded = lastResourceTime - firstResourceTime;
  // 将 FCP 时间，减去最后加载完成的资源时间，作为 JS 的执行时间
  const JSRuntime = FCPTime - lastResourceTime;

  const res: PerformanceType = {
    valid: false,
    connectTime: formatNum(connectTime),
    HTMLDownloaded: formatNum(HTMLDownloaded),
    resourceLoaded: formatNum(resourceLoaded),
    JSRuntime: formatNum(JSRuntime),
    FCPTime: formatNum(FCPTime),
    cacheType: getCacheType(assetsEntries),
    msg: JSON.stringify(formatEntries(assetsEntries)),
    dnsLookup: t.domainLookupEnd - t.domainLookupStart,
    tcp: t.connectEnd - t.connectStart,
    ssl: t.secureConnectionStart === 0 ? 0 : t.requestStart - t.secureConnectionStart,
    ttfb: t.responseStart - t.requestStart,
    idleTime: formatNum(FCPTime - JSRuntime - resourceLoaded - HTMLDownloaded - connectTime),
    lastResourceTime,
  };

  res.valid = validation(res);

  return res;
};

/** 只记录在 ASSETS_TYPE 和 固定域名 的资源加载时间 */
const processEntries = (entries: PerformanceResourceTiming[]) => entries
  .filter(entry => ASSETS_TYPE.indexOf((entry).initiatorType) !== -1);
// && checkDomain(entry.name));

/** 检查是否在指定域名内 */
// const checkDomain = (name: string) => {
//   for (const url of URL_TYPE) {
//     if (name.includes(url)) {
//       return true;
//     }
//   }
// };

/** 检查缓存类型 */
const getCacheType = (entries: PerformanceResourceTiming[]) => {
  const len = entries.length;
  // 资源加载完成时间 - 资源开始加载时间 小于 100 ms 认为是本地缓存，但这中策略在 android 手机的误差非常大
  const cacheEntries = entries.filter(entry => entry.responseEnd - entry.startTime <= 100);
  if (cacheEntries.length === 0) {
    return CacheType.noCache;
  } if (cacheEntries.length >= len) {
    return CacheType.allCache;
  }
  return CacheType.partialCache;
};

const formatEntries = (entries: PerformanceResourceTiming[]) => entries.map(entry => ({
  duration: formatNum(entry.duration),
  name: entry.name,
  startTime: formatNum(entry.startTime),
  endTime: formatNum(entry.responseEnd),
}));

export const formatNum = (num: number) => +num.toFixed(2);

/** 检验数据是否有效 */
const validation = (info: PerformanceType) => {
  // 若无法获取到 PerformanceResourceTiming，返回无效
  if (info.msg.length <= 0) {
    return false;
  }
  // 若值友为负数的情况，返回无效
  for (const key of Object.keys(info)) {
    if (typeof info[key] === 'number' && info[key] < 0) {
      return false;
    }
  }
  return true;
};

const markDoms: { [timing: number]: Element[]; } = {};

/** 监听页面元素打点，后续再使用 */
export const firstScreenTiming = () => {
  const observeDom: MutationObserver = new MutationObserver((mutations) => {
    // 由于一次“MutationObserver”回调函数包含了多个“mutaion”，多个“mutation”可能修改了同一个dom节点，
    // 如果不聚合直接算dom节点数量的话，将重复计算
    const change = {
      roots: [],
      rootsDomNum: [],
      time: performance.now(),
    };
    mutations.forEach((mutation) => {
      if (!mutation || !mutation.addedNodes || !mutation.addedNodes.forEach) return;

      mutation.addedNodes.forEach((ele) => {
        if (ele.nodeType === 1 && (
          (ele as Element).hasAttribute('AEGIS-FIRST-SCREEN-TIMING')
          || (ele as Element).querySelector('[AEGIS-FIRST-SCREEN-TIMING]')
        )
        ) {
          console.log('performance', ele, new Date().getTime() - performance.timing.navigationStart);
          if (!Object.prototype.hasOwnProperty.apply(markDoms, [change.time])) {
            markDoms[change.time] = [];
          }
        }
      });
    });
  });
  observeDom.observe(document, {
    childList: true,
    subtree: true,
  });
};


type PerformanceType = {
  /** 是否有效 */
  valid: boolean,
  /** 第一个有意义的展示时间 */
  FCPTime: number;
  /** navigationStart 至开始下载 HTML 时间  */
  connectTime: number;
  /** HTML资源下载时间*/
  HTMLDownloaded: number,
  /** 资源加载时间 */
  resourceLoaded: number,
  /** 资源加载完毕至DCL时间 */
  JSRuntime: number,
  /** 闲置时间 */
  idleTime: number,
  /** 缓存类型 */
  cacheType: CacheType,
  /** 最后一个资源加载完成时间 */
  lastResourceTime: number,
  /** 资源加载 PerformanceResourceTiming 数组 */
  msg: string,
  dnsLookup: number,
  tcp: number,
  ssl: number,
  ttfb: number,
};

enum CacheType {
  /** 无缓存 */
  noCache = 0,
  /** 部分缓存 */
  partialCache,
  /** 全缓存 */
  allCache,
};
